import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

import { Mutation as RootMutation } from 'graphql/models/generated';

export const UPDATE_POSITION_DESCRIPTION_MUTATION = gql`
  mutation setLineDescription(
    $documentVersion: DocumentVersionInput!
    $lineId: String!
    $description: String!
  ) {
    quotes {
      modify(documentVersion: $documentVersion) {
        line(id: $lineId) {
          setDescription(description: $description) {
            documentId
            revision
            status
            snkModifier {
              profile {
                firstName
                lastName
              }
            }
          }
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class UpdatePositionDescriptionMutation extends Mutation<RootMutation> {
  document = UPDATE_POSITION_DESCRIPTION_MUTATION;
}
